import React from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { t } from 'i18next';
import { useAssetTypesState } from '../../../stores/Configuration/AssetTypesProvider'
import ModalComponent2 from '../../Modals/ModalComponent2';
import useMountEffect from '../../../utils/hooks/useMountEffect';
import AssetTypeItem from './AssetTypeItem';
import { FixedSizeList as List } from 'react-window';

const StyledWrapper = styled.div`
  @media screen and (min-width: 1080px) {
    max-width: calc(100% - 480px);
    min-width: 600px;
  }
`


const AssetTypesOverview = () => {
  const { assetTypes, getAssetTypes, deleteAssetType, loadingStates, errorStates, setSuccessStates, deleteAssetTypeId, setDeleteAssetTypeId } = useAssetTypesState()
  const navigate = useNavigate()
  const clearedAssetTypes = assetTypes.filter(item => !item.isSystemType) || []
  useMountEffect(() => {
    getAssetTypes()
  })

  const editRow = (assetTypeId) => {
    let path = `/assetTypesAdministration/edit/${assetTypeId}`
    navigate(path)
  }

  return (
    <>
      <StyledWrapper>
        {(loadingStates.assetTypes && !clearedAssetTypes.length)
          ? <div className="d-flex align-items-center justify-content-center"><Spinner animation='border' variant='primary' /></div>
          :
          <List
            height={800}
            itemCount={clearedAssetTypes.length}
            itemSize={30}
          >
            {({ index, style }) => <div style={style}><AssetTypeItem key={clearedAssetTypes[index].id} assetType={clearedAssetTypes[index]} editRow={editRow} setDeleteAssetTypeId={setDeleteAssetTypeId} /></div>}
          </List>
        }
      </StyledWrapper>
      {deleteAssetTypeId && <ModalComponent2
        ModalTitle={t('assetTypes:deleteAssetType')}
        BodyPart1={t('assetTypes:deleteBody')}
        button1Function={() => deleteAssetType(deleteAssetTypeId)}
        button1Text={t('delete')}
        button1Loading={loadingStates.deleteAssetType}
        button1Variant="danger"
        bodyStyle="alert alert-danger"
        functionCancel={() => { setDeleteAssetTypeId(''); setSuccessStates({}) }}
        error={errorStates?.deleteAssetType?.value}
      />}
    </>
  )
}

export default AssetTypesOverview